import {Customer} from '../models';

export const getCustomers = (data: any): Customer[] => data.map(getCustomer);

export const getCustomer = (data: any): Customer => ({
  id: data.id,
  firstName: data.firstname,
  lastName: data.lastname,
  company: data.company,
  email: data.email,
});
